import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'

export const AUTO_REPLY_ENABLED_PROVIDERS: ExternalIntegrationEnum[] = [ExternalIntegrationEnum.Instagram]
